import { UpsertAttributesOptionsRequestItem } from "./UpsertAttributesOptionsRequestItem";

export class WeeekOptionsUpsertPrioritiesRequest {
  ProjectId!: number;
  Attributes!: Array<UpsertAttributesOptionsRequestItem>;
  constructor(obj?: Partial<WeeekOptionsUpsertPrioritiesRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
